import { render, staticRenderFns } from "./Speakia.vue?vue&type=template&id=751291f8&scoped=true"
import script from "./Speakia.vue?vue&type=script&lang=js"
export * from "./Speakia.vue?vue&type=script&lang=js"
import style0 from "./Speakia.vue?vue&type=style&index=0&id=751291f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751291f8",
  null
  
)

export default component.exports